var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "form-table"
  }, [_c('div', {
    staticClass: "form-table__row"
  }, [_c('div', {
    staticClass: "form-table__th"
  }, [_vm._v("성명")]), _c('div', {
    staticClass: "form-table__td"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.writer.name,
      expression: "form.writer.name"
    }],
    attrs: {
      "type": "text",
      "id": "writer-name"
    },
    domProps: {
      "value": _vm.form.writer.name
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.writer, "name", $event.target.value);
      }, _vm.input]
    }
  })])]), _c('div', {
    staticClass: "form-table__row"
  }, [_c('div', {
    staticClass: "form-table__th"
  }, [_vm._v("연락처")]), _c('div', {
    staticClass: "form-table__td"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.writer.phone,
      expression: "form.writer.phone"
    }],
    attrs: {
      "type": "hidden",
      "id": "writer-phone"
    },
    domProps: {
      "value": _vm.form.writer.phone
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.writer, "phone", $event.target.value);
      }, _vm.input]
    }
  }), _c('div', {
    staticClass: "form-tel"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.writer.phone1,
      expression: "form.writer.phone1"
    }],
    staticClass: "select",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form.writer, "phone1", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "010"
    }
  }, [_vm._v("010")]), _c('option', {
    attrs: {
      "value": "011"
    }
  }, [_vm._v("011")]), _c('option', {
    attrs: {
      "value": "016"
    }
  }, [_vm._v("016")]), _c('option', {
    attrs: {
      "value": "017"
    }
  }, [_vm._v("017")]), _c('option', {
    attrs: {
      "value": "019"
    }
  }, [_vm._v("019")])]), _c('span', {
    staticClass: "text"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.writer.phone2,
      expression: "form.writer.phone2"
    }],
    staticClass: "input",
    attrs: {
      "type": "tel",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.form.writer.phone2
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.writer, "phone2", $event.target.value);
      }
    }
  }), _c('span', {
    staticClass: "text"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.writer.phone3,
      expression: "form.writer.phone3"
    }],
    staticClass: "input",
    attrs: {
      "type": "tel",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.form.writer.phone3
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.writer, "phone3", $event.target.value);
      }
    }
  })])])]), _c('div', {
    staticClass: "form-table__row"
  }, [_c('div', {
    staticClass: "form-table__th"
  }, [_vm._v("이메일")]), _c('div', {
    staticClass: "form-table__td"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.writer.email,
      expression: "form.writer.email"
    }],
    attrs: {
      "type": "hidden",
      "id": "writer-email"
    },
    domProps: {
      "value": _vm.form.writer.email
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.writer, "email", $event.target.value);
      }, _vm.input]
    }
  }), _c('div', {
    staticClass: "form-email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.writer.email1,
      expression: "form.writer.email1"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.form.writer.email1
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.writer, "email1", $event.target.value);
      }
    }
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v("@")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.writer.email2,
      expression: "form.writer.email2"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.form.writer.email2
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.writer, "email2", $event.target.value);
      }
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.writer.email3,
      expression: "form.writer.email3"
    }],
    staticClass: "select",
    on: {
      "input": function input($event) {
        return _vm.form.writer.email2 = $event.target.value;
      },
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form.writer, "email3", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("직접입력")]), _c('option', {
    attrs: {
      "value": "naver.com"
    }
  }, [_vm._v("naver.com")]), _c('option', {
    attrs: {
      "value": "daum.net"
    }
  }, [_vm._v("daum.net")]), _c('option', {
    attrs: {
      "value": "google.com"
    }
  }, [_vm._v("google.com")])])])])]), _c('div', {
    staticClass: "form-table__row"
  }, [_c('div', {
    staticClass: "form-table__th"
  }, [_vm._v("유형")]), _c('div', {
    staticClass: "form-table__td"
  }, [_c('div', {
    staticClass: "radio-wrap"
  }, [_c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.meta.type,
      expression: "form.meta.type"
    }],
    staticClass: "input",
    attrs: {
      "type": "radio",
      "value": "문의"
    },
    domProps: {
      "checked": _vm._q(_vm.form.meta.type, "문의")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.form.meta, "type", "문의");
      }
    }
  }), _c('i', {
    staticClass: "icon"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v("문의")])]), _c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.meta.type,
      expression: "form.meta.type"
    }],
    staticClass: "input",
    attrs: {
      "type": "radio",
      "value": "제휴"
    },
    domProps: {
      "checked": _vm._q(_vm.form.meta.type, "제휴")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.form.meta, "type", "제휴");
      }
    }
  }), _c('i', {
    staticClass: "icon"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v("제휴")])])])])]), _c('div', {
    staticClass: "form-table__row"
  }, [_c('div', {
    staticClass: "form-table__th"
  }, [_vm._v("내용")]), _c('div', {
    staticClass: "form-table__td"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.content,
      expression: "form.content"
    }],
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": _vm.form.content
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "content", $event.target.value);
      }, _vm.input]
    }
  })])])]), _vm._m(0), _c('div', {
    staticClass: "form-buttons"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('save');
      }
    }
  }, [_vm._v(" 접수하기 ")])], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "terms-box"
  }, [_c('div', {
    staticClass: "terms-box__tit"
  }, [_vm._v("개인정보 취급방침")]), _c('div', {
    staticClass: "terms-box__txt"
  }, [_c('p', [_vm._v("※ 총 칙")]), _c('br'), _c('p', [_vm._v("1. 주식회사 앤에프티 코리아는 \"정보통신망이용촉진및정보보호등에관한법률\"상의 개인정보보호 규정과 정보통신부가 제정한 \"개인정보보호지침\" 및 \"개인정보의 기술적/관리적 보호조치 기준\"을 준수하고 있습니다. 또한 \"개인정보보호정책\"을 제정하여 회원들의 개인정보 보호를 위해 최선을 다하겠음을 선언합니다.")]), _c('br'), _c('p', [_vm._v("2. 주식회사 앤에프티코리아의 \"개인정보보호정책\"은 관련 법률 및 정부 지침의 변경과 내부 방침 변경에 의해 변경될 수 있습니다. \"개인정보보호방침\"이 변경될 경우 변경사항은 홈페이지의 공지사항에 최소 7일간 게시됩니다.")]), _c('br'), _c('br'), _c('p', [_vm._v("※ 개인정보")]), _c('br'), _c('p', [_vm._v("주식회사 앤에프티코리아는 귀하께서 이용약관의 내용에 대해 \"동의한다\" 버튼 또는 \"동의하지 않는다\" 버튼을 클릭할 수 있는 절차를 마련하여, \"동의한다\" 버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다. 또한, 귀하께서 “동의한다” 버튼을 클릭하면 아래의 개인정보 수집 항목 중 “비밀번호”와 “주민등록번호”를 제외한 나머지 항목들은 주식회사 앤에프티코리아 서비스를 이행하기 위해 외주업체에 제공하는 것에 대해 동의한 것으로 간주합니다.")]), _c('br'), _c('p', [_vm._v("1. \"개인정보\"의 범위는 정보통신망이용촉진및정보보호등에관한법률에서 규정하는 내용에 따라, \"생존하는 개인에 관한 정보로서 당해 정보에 포함되어 있는 성명, 주민등록번호 등의 사항에 의하여 당해 개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 식별할 수 없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을 포함한다)\"를 의미합니다.")]), _c('br'), _c('p', [_vm._v("2. 주식회사 앤에프티코리아의 이용자 확인, 대금결제, 이용 서비스의 소유자 확인, 개별회원에게 맞춤화된 서비스, 기타 부가서비스 등을 위하여 회원들의 개인정보를 수집ㆍ이용 합니다. 수집하는 개인정보 항목에 따른 구체적인 수집목적 및 이용 목적은 다음과 같습니다.")]), _c('p', [_vm._v("- 성명, 아이디, 비밀번호, 전화번호, 사용 SNS 정보: 회원제 서비스 이용에 따른 본인 확인 절차 및 정보제공에 이용,")]), _c('p', [_vm._v("- 이용 서비스의 소유자 확인")]), _c('p', [_vm._v("- 이메일주소, 전화번호, 팩스번호 : 도메인 관리 규정에 따른 필수 정보 확보, 고지사항 전 달, 불만처리 등을 위한 원활한 의사 소통")]), _c('p', [_vm._v("- 경로의 확보, 새로운 서비스 및 이벤트 정보 등의 안내")]), _c('p', [_vm._v("- 은행정보, 신용카드 정보 : 유료서비스 이용 및 구매에 대한 결제")]), _c('p', [_vm._v("- 주소 : 도메인 정보조회 제공, 청구서 배송지 확인")]), _c('p', [_vm._v("- 쿠키 ( 아이디 ) : 쿠키 운영을 통해 방문자들의 아이디를 자동 분석하여 등급별 차등화된 서비스 적용.")]), _c('p', [_vm._v("고객과 회원은 웹브라우저에서 옵션을 설정함으로써 쿠키가 저장될 때마다 확인을 거치거 나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. 그러나 쿠키의 저장을 거부할 경 우 웹서비스 이용이 제한될 수 있습니다.")]), _c('p', [_vm._v("3. 주식회사 앤에프티코리아는 회원 개인정보를 위탁관리하지 않습니다.")]), _c('br'), _c('p', [_vm._v("4. 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적 지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 요구하지 않습니 다.")]), _c('br'), _c('p', [_vm._v("5. 개인정보의 보유 기간은 \"회원이 주식회사 앤에프티코리아 홈페이지에 가입하는 순간부터 해지 신청 순간까지\"입니다. 회원DB는 탈퇴 신청자의 개인정보가 탈퇴 즉시 삭제하지만 수집목적 및 제공받은 목적이 달성된 경우에도 법률의 규정에 의하여 보존할 필요성이 있는 경우에는 법률의 규정에 따라 고객의 개인정보를 보유할 수 있습니다.")]), _c('p', [_vm._v("- 계약 또는 청약철회 등에 관한 기록 : 5년")]), _c('p', [_vm._v("PC에 저장할 경우 암호화하여 저장하도록 시스템을 운영하고 있습니다.")]), _c('br'), _c('p', [_vm._v("※ 의견수렴 및 불만처리")]), _c('br'), _c('p', [_vm._v("주식회사 앤에프티코리아 회원 중 개인정보보호와 관련하여 불만이 있으신 분은 개인정보 관리책임자에게 의견을 주시면, 접수 즉시 조치하여 처리결과를 통보해 드리겠습니다. 개인정보 무단 유출이나 기타 심각한 개인정보 침해 시에는 정부에서 설치하여 운영중인 개인정보침해 신고센터(http://www.cyberpr ivacy.or.kr, http://www.1336.or.kr, 전화 02-1336,)에 불만처리 또는 중재를 신청하실 수도 있습니다.")]), _c('br'), _c('p', [_vm._v("※ 개인정보관리 계획의 수립 및 시행")]), _c('br'), _c('p', [_vm._v("주식회사 앤에프티코리아는 회사 규정에 별도의 전산관리규정을 마련하여 다음과 같은 사항을 준수하겠습니다.")]), _c('br'), _c('p', [_vm._v("1. 개인정보관리책임자의 지정 등 개인정보보호 조칙의 구성, 운영에 관한 사항")]), _c('p', [_vm._v("2. 개인정보취급자의 교육에 관한 사항")]), _c('p', [_vm._v("3. 개인정보처리시스템의 접속 기록 유지 및 정기적인 확인 감독")]), _c('p', [_vm._v("4. 개인정보 출력 및 복사시의 보호조치")]), _c('p', [_vm._v("5. 기타 개인정보 보호를 위해 필요한 사항")]), _c('br'), _c('p', [_vm._v("※ 개인정보 관리 담당자")]), _c('br'), _c('p', [_vm._v("주식회사 앤에프티코리아의 개인정보에 대한 의견수렴 및 불만처리를 담당하는 개인정보 관리담당자를 지정하고 있습니다.")]), _c('br'), _c('p', [_vm._v("- 개인정보 관리 담당자")]), _c('p', [_vm._v("성 명 : 임종령")]), _c('p', [_vm._v("직 책 : 대표이사")]), _c('p', [_vm._v("전화번호 : 1661-9464")]), _c('p', [_vm._v("E-mail : xyz@semoo.co.kr")]), _c('br'), _c('p', [_vm._v("※ 아동의 회원 가입에 대해")]), _c('br'), _c('p', [_vm._v("1. 주식회사 앤에프티코리아는 아동의 개인정보를 보호하기 위하여 만 14세 미만의 아동이 회원 가입을 신청할 경우 법정대리인(부모)의 동의가 있어야 합니다. 부모님의 허락을 받지않은 14세 미만의 미성년자에 대해서는 주식회사 앤에프티코리아에서 임의로 회원에서 제외 할 수 있습니다.")]), _c('br'), _c('p', [_vm._v("2. 만 14세 미만 미성년자의 법정대리인은 대리인의 책임하에 있는 미성년자의 개인정보에 대한 열람, 정정, 동의철회를 요청할 수 있으며, 이러한 요청이 있을 경우 주식회사 앤에프티코리아는 지체없이 필요한 조치를 취하겠습니다.")]), _c('br'), _c('p', [_vm._v("※ 미성년자 거래시 철회에 대해")]), _c('br'), _c('p', [_vm._v("주식회사 앤에프티코리아는 미성년자와의 거래시 사전에 법정대리인(부모)의 동의를 구할 의무가 있으며, 법정대리인(부모)의 동의를 얻지 못한 거래의 경우, 거래를 취소할 수 있습니다. 또한 거래 당사자인 미성년자의 법정대리인(부모)이 거래 성립 후 7일 이내에 철회를 요청할 경우, 거래를 철회하겠습니다.")]), _c('br'), _c('p', [_vm._v("※ 광고성 정보 전송에 대해")]), _c('br'), _c('p', [_vm._v("1. 주식회사 앤에프티코리아는 회원을 대상으로 주식회사 앤에프티코리아가 제공하고 있는 서비스에 대한 안내, 서비스에 대한 공지 등에 대한 메일을 자유롭게 보낼 수 있습니다.")]), _c('br'), _c('p', [_vm._v("2. 주식회사 앤에프티코리아는 회원을 대상으로 광고성 정보를 전송할 수 있습니다. 단, 이러한 경우에는 (광고)라는 문구를 표시하여 회원들이 광고성 정보임을 쉽게 파악할 수 있게 하며, 수신거부 의사를 밝힌 회원에게는 광고성 정보를 전송하지 않겠습니다.​")])])]);
}]

export { render, staticRenderFns }